import { useState } from "react";
import { Collapse, Spin } from "antd";
import { Checkbox } from "@components/Checkbox";
import { Button } from "@components/Button";
import cs from "./AdditionalProcessings.module.scss";

const { Panel } = Collapse;

export const Metal = ({ machinelessServices, onChange, onSave }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Collapse
      defaultActiveKey={["METAL"]}
      className={`ProcessingType ${cs.panel}`}
      expandIconPosition="right"
    >
      <Panel header="Obróbka dodatkowa metali" key="METAL">
        <div className={cs.checkboxContainer}>
          <Checkbox
            label="Szlifowanie"
            style={{ fontSize: "18px" }}
            checked={machinelessServices.includes(123)}
            onChange={(e) => onChange(123, e.target.checked)}
          />

          <Checkbox
            label="Piaskowanie"
            style={{ fontSize: "18px" }}
            checked={machinelessServices.includes(124)}
            onChange={(e) => onChange(124, e.target.checked)}
          />

          <Checkbox
            label="Wiercenie otworów w metalu"
            style={{ fontSize: "18px" }}
            checked={machinelessServices.includes(125)}
            onChange={(e) => onChange(125, e.target.checked)}
          />

          <Checkbox
            label="Gwintowanie otworów"
            style={{ fontSize: "18px" }}
            checked={machinelessServices.includes(126)}
            onChange={(e) => onChange(126, e.target.checked)}
          />

          <Checkbox
            label="Pogłębianie stożkowe otworów w metalu"
            style={{ fontSize: "18px" }}
            checked={machinelessServices.includes(127)}
            onChange={(e) => onChange(127, e.target.checked)}
          />

          <Checkbox
            label="Pogłębianie walcowe otworów w metalu"
            style={{ fontSize: "18px" }}
            checked={machinelessServices.includes(128)}
            onChange={(e) => onChange(128, e.target.checked)}
          />

          <div className="mt4 ml-auto">
            <Spin spinning={isLoading}>
              <Button type="primary" size="small" onClick={handleSave}>
                Zapisz zmiany
              </Button>
            </Spin>
          </div>
        </div>
      </Panel>
    </Collapse>
  );

  function handleSave() {
    setIsLoading(true);

    onSave();

    setTimeout(() => {
      setIsLoading(false);
    }, 300);
  }
};
